// ModalUpgradePlan.jsx
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
    ThemeProvider,
    Dialog,
    IconButton,
    Typography,
    Box,
    Button,
    Card,
    Switch,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Collapse,
    Radio,
    RadioGroup,
    OutlinedInput,
} from '@material-ui/core';
import {
    Close as CloseIcon,
    CheckCircle as CheckCircleIcon,
    CreditCard as CreditCardIcon,
    WhatsApp as WhatsAppIcon,
    ArrowBack as ArrowBackIcon,
    Security as ShieldIcon,
    Headset as HeadsetIcon,
    EmojiEvents as TrophyIcon,
    Check as CheckIcon,
    ExpandMore as ExpandMoreIcon,
    EmojiEvents as StarIcon,
    AddCircle,
} from '@material-ui/icons';
import { useStyles, theme } from './index.styles';

const appendStripePaymentLinkParams = (baseUrl, storeId) => {
    const params = new URLSearchParams();
    params.set('locale', 'es-419');
    if (storeId != null && storeId !== '') {
        params.set('client_reference_id', String(storeId));
    }
    const join = baseUrl.includes('?') ? '&' : '?';
    return `${baseUrl}${join}${params.toString()}`;
};

const ModalUpgradePlan = ({ open, onClose, storeId }) => {
    const classes = useStyles();
    const [screen, setScreen] = useState('plans');
    const [billingPeriod, setBillingPeriod] = useState('annual');
    const [expandedPayment, setExpandedPayment] = useState('payu');
    const [autoRenew, setAutoRenew] = useState(true);
    const [promoCode, setPromoCode] = useState('');
    const [freeExpanded, setFreeExpanded] = useState(false);
    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState('');
    // const paymentUrl = 'https://biz.payulatam.com/L0f526d8955B8A6';
    // const monthlyPlanPaymentUrl = 'https://biz.payulatam.com/L0f526d8955B8A6';
    const paymentUrl = {
        oneTimeMonthly: 'https://buy.stripe.com/9B67sL8ai8ysdAUdGTfIs0r',
        monthlySubscription: 'https://buy.stripe.com/4gM00j1LUbKE7cweKXfIs0q',
        oneTimeAnnual: 'https://buy.stripe.com/bJeeVd1LU2a4bsMauHfIs0n',
        annualSubscription: 'https://buy.stripe.com/28E6oH0HQ2a47cwdGTfIs0s',
    };

    const freeFeatures = [
        'Tu tienda online conectada a WhatsApp lista para compartir',
        'Publica hasta 20 productos con foto, precio y descripción',
        'Conecta 1 línea de WhatsApp para recibir y gestionar pedidos',
        'Crea categorías ilimitadas para organizar tu catálogo como un profesional',
        'Organiza a todos tus clientes sin límite de contactos',
        'Recibe y gestiona pedidos ilimitados desde un solo lugar',
        'Lleva el control de tu stock con el sistema de inventario integrado',
        'Subdominio gratis (ejemplo: tutienda.ecometri.shop)',
        'Comparte tu tienda con un enlace o código QR desde cualquier canal',
        'Todos los pedidos llegan directo a tu chat de WhatsApp',
        'Tráfico sin límites: sesiones ilimitadas, sin bloqueos ni topes de visitas',
    ];

    const proFeatures = [
        'Productos ilimitados para escalar sin límites',
        'Subcategorías para organizar tu catálogo',
        'Conecta hasta 5 líneas de WhatsApp',
        'Conecta tu propio dominio personalizado',
        'Recibe pagos en línea (PayU, Wompi, Paypal, Mercado Pago, Contra Entrega etc.)',
        'Cupones de descuento para tus clientes',
        'Carga masiva de productos desde Excel',
        'Pixel de Facebook y Google Analytics',
        'Soporte prioritario por WhatsApp',
    ];

    useEffect(() => setExpandedPayment('payu'), []);
    const togglePaymentOption = (opt) => setExpandedPayment(expandedPayment === opt ? '' : opt);
    // const onConfigureStoreClick = () => {
    //     window.location.href = '/config';
    // };

    const handleValidatePromoCode = () => {
        console.log('validate', promoCode);
    };

    const handleCompletePayment = () => {
        if (selectedPaymentMethod === '') return;
        if (selectedPaymentMethod === 'payu') {
            if (billingPeriod === 'monthly') {
                if (autoRenew) {
                    window.open(
                        appendStripePaymentLinkParams(paymentUrl.monthlySubscription, storeId),
                        '_blank',
                        'noopener,noreferrer'
                    );
                    return setScreen('success');
                }
                window.open(
                    appendStripePaymentLinkParams(paymentUrl.oneTimeMonthly, storeId),
                    '_blank',
                    'noopener,noreferrer'
                );
                return setScreen('success');
            }
            if (autoRenew) {
                window.open(
                    appendStripePaymentLinkParams(paymentUrl.annualSubscription, storeId),
                    '_blank',
                    'noopener,noreferrer'
                );
                return setScreen('success');
            }
            window.open(
                appendStripePaymentLinkParams(paymentUrl.oneTimeAnnual, storeId),
                '_blank',
                'noopener,noreferrer'
            );
            return setScreen('success');
        }
        if (selectedPaymentMethod === 'whatsapp') {
            window.open(
                'https://wa.me/17543296020?text=Hola%20Ecometri%2C%20me%20gustar%C3%ADa%20activar%20el%20plan%20PRO%20de%20mi%20tienda',
                '_blank',
                'noopener,noreferrer'
            );
        }
        return setScreen('success');
    };

    const handleOpenWhatsapp = () => {
        window.open(
            'https://wa.me/17543296020?text=Hola%20Ecometri%2C%20He%20pagado%20a%20trav%C3%A9s%20de%20PayU%20y%20necesito%20ayuda%20para%20activar%20mi%20plan.',
            '_blank',
            'noopener,noreferrer'
        );
        onClose();
    };

    // --- PLAN SCREEN ---
    const renderPlans = () => (
        <Dialog open={open} onClose={onClose}>
            <Box className={classes.header}>
                <Box display="flex" justifyContent="flex-end" alignItems="center">
                    <IconButton size="small" className={classes.closeButton} onClick={onClose}>
                        <CloseIcon fontSize="small" />
                    </IconButton>
                </Box>
                <Typography variant="h5" align="center" style={{ fontWeight: 'bold' }}>
                    Elige el plan que mejor se adapta a tu tienda
                </Typography>
                <Typography variant="body2" align="center" color="textSecondary">
                    Comienza gratis. Escala cuando estés listo.
                </Typography>
            </Box>

            <Box className={classes.content}>
                <Card className={classes.freeCard} elevation={0}>
                    <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                        Plan Gratuito
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Ideal para empezar a vender
                    </Typography>

                    <Box mt={2} mb={3}>
                        <Typography variant="h4" style={{ fontWeight: 'bold' }}>
                            $0
                        </Typography>
                        <Typography variant="body2" color="textSecondary">
                            / mes
                        </Typography>
                    </Box>

                    <List dense>
                        {freeFeatures.slice(0, 5).map((f) => (
                            <ListItem key={f}>
                                <ListItemIcon>
                                    <CheckCircleIcon style={{ color: '#10b981' }} />
                                </ListItemIcon>
                                <ListItemText primary={f} />
                            </ListItem>
                        ))}
                        <Collapse in={freeExpanded} timeout="auto" unmountOnExit>
                            {freeFeatures.slice(5).map((f) => (
                                <ListItem key={f}>
                                    <ListItemIcon>
                                        <CheckCircleIcon style={{ color: '#10b981' }} />
                                    </ListItemIcon>
                                    <ListItemText primary={f} />
                                </ListItem>
                            ))}
                        </Collapse>
                        <ListItem button onClick={() => setFreeExpanded((value) => !value)}>
                            <ListItemIcon>
                                <ExpandMoreIcon
                                    style={{
                                        transform: freeExpanded ? 'rotate(180deg)' : 'none',
                                        transition: 'transform 0.2s',
                                    }}
                                />
                            </ListItemIcon>
                            <ListItemText
                                primary={freeExpanded ? 'Ver menos características' : 'Ver más'}
                                style={{ color: '#2563eb', fontWeight: 500 }}
                            />
                        </ListItem>
                    </List>
                </Card>
                <div className={classes.proBadgeContainer}>
                    <Box className={classes.proBadge}>
                        <StarIcon style={{ fontSize: 16, color: '#92400e' }} />
                        <Typography variant="caption" style={{ fontWeight: 'bold' }}>
                            Pro
                        </Typography>
                    </Box>
                </div>
                <Card className={classes.proCard} elevation={0}>
                    <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                        Plan Pro
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                        Desbloquea todo el potencial de tu tienda
                    </Typography>

                    {/* Toggle — mensual oculto temporalmente
                    <Box className={classes.billingToggle} mb={2}>
                        {['monthly', 'annual'].map((p) => (
                            <button
                                key={p}
                                className={`${classes.toggleButton} ${
                                    billingPeriod === p ? 'active' : 'inactive'
                                }`}
                                onClick={() => setBillingPeriod(p)}
                            >
                                {p === 'monthly' ? 'Mensual' : 'Anual'}
                            </button>
                        ))}
                    </Box>
                    */}

                    {/* Pricing — solo plan anual por ahora */}
                    <Typography variant="h4">$169 USD / año</Typography>
                    {/* Mensual oculto temporalmente
                    {billingPeriod === 'monthly' ? (
                        <React.Fragment>
                            <Typography variant="h4">$16.99 USD / mes</Typography>
                            <Typography variant="caption" color="textSecondary">
                                Total anual: $203.88 USD
                            </Typography>
                        </React.Fragment>
                    ) : (
                        <React.Fragment>
                            <Typography variant="h4">$169 USD / año</Typography>
                            ...
                        </React.Fragment>
                    )}
                    */}
                    {/* Banner ahorro oculto temporalmente
                            <div style={{ margin: '12px auto', textAlign: 'left', width: '100%' }}>
                                <div style={{ display: 'inline-flex', ... }}>
                                    <span>Equivale a $14.08 USD/mes - </span>
                                    <span style={{ fontWeight: 700 }}>¡Ahorra 17%!</span>
                                </div>
                            </div>
                    */}

                    <div
                        style={{
                            backgroundColor: '#eef6ff',
                            borderRadius: 10,
                            padding: '12px 18px',
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '8px',
                            color: '#1d4ed8',
                            fontWeight: 'bold',
                            fontSize: '14px',
                            width: '100%',
                            margin: '12px auto',
                        }}
                    >
                        <AddCircle />
                        <span style={{ color: '#1e3a8a' }}>Todo en Plan Gratuito, más:</span>
                    </div>

                    <List dense>
                        {proFeatures.map((f) => (
                            <>
                                <ListItem key={f}>
                                    <ListItemIcon>
                                        <CheckCircleIcon style={{ color: '#10b981' }} />
                                    </ListItemIcon>
                                    <ListItemText primary={f} />
                                </ListItem>
                                {f === 'Conecta tu propio dominio personalizado' && (
                                    <Typography
                                        variant="caption"
                                        color="textSecondary"
                                        style={{
                                            marginLeft: 40,
                                            marginTop: -8,
                                            marginBottom: 8,
                                            display: 'block',
                                        }}
                                    >
                                        (No incluye compra ni gestión del dominio)
                                    </Typography>
                                )}
                            </>
                        ))}
                    </List>
                </Card>
                {/* Actions */}
                <Box mt={3} style={{ textAlign: 'center' }}>
                    <Button
                        fullWidth
                        className={classes.actionButton}
                        startIcon={<StarIcon />}
                        onClick={() => setScreen('payment')}
                    >
                        Activar Plan Pro
                    </Button>
                    <Button fullWidth className={classes.secondaryButton} style={{ marginTop: 12 }}>
                        Seguir con plan gratuito
                    </Button>
                    <span>Cancela cuando quieras. Sin comisiones por venta.</span>
                </Box>
            </Box>
        </Dialog>
    );

    // --- PAYMENT SCREEN ---
    const renderPayment = () => {
        // dynamic price values
        const monthlyPrice = 16.99;
        const annualPrice = 169;

        const displayPrice =
            billingPeriod === 'monthly'
                ? `$${monthlyPrice.toFixed(2)} / mes`
                : `$${annualPrice.toFixed(2)} / año`;

        const totalToPay =
            billingPeriod === 'monthly'
                ? `$${monthlyPrice.toFixed(2)} USD`
                : `$${annualPrice.toFixed(2)} USD`;

        // const savingsText =
        //     billingPeriod === 'monthly' ? 'Ahorra $10 este mes' : 'Ahorra 20% con el plan anual';

        return (
            <Dialog open={open} onClose={onClose}>
                <Box className={classes.header}>
                    <IconButton edge="start" onClick={() => setScreen('plans')}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                        Elige cómo pagar tu Plan Pro
                    </Typography>
                    <div className={classes.paymentPlanBadgeContainer}>
                        <span className={classes.paymentPlanBadge}>👑</span>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                flexGrow: 1,
                            }}
                        >
                            <span className={classes.paymentPlanName}>Plan Pro</span>
                            <span className={classes.paymentPlanPrice}>{displayPrice}</span>
                        </div>
                    </div>
                </Box>

                <Box className={classes.content} style={{ position: 'relative' }}>
                    {/* Radio Group for Payment Method */}
                    <RadioGroup
                        name="paymentMethod"
                        value={selectedPaymentMethod}
                        onChange={(e) => setSelectedPaymentMethod(e.target.value)}
                    >
                        {/* PayU Option */}
                        <Box className={classes.paymentOption}>
                            <Button
                                className={classes.paymentButton}
                                onClick={() => togglePaymentOption('payu')}
                            >
                                <Box display="flex" style={{ gap: 8 }}>
                                    <Radio
                                        checked={selectedPaymentMethod === 'payu'}
                                        value="payu"
                                        color="primary"
                                    />
                                    <CreditCardIcon color="primary" />
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                        }}
                                    >
                                        <Typography>Pagar con Stripe/Tarjeta</Typography>
                                        <Typography variant="body2" style={{ color: '#C0C1BE' }}>
                                            Transacción segura
                                        </Typography>
                                    </div>
                                </Box>
                                <ExpandMoreIcon
                                    style={{
                                        transform:
                                            expandedPayment === 'payu' ? 'rotate(180deg)' : 'none',
                                    }}
                                />
                            </Button>
                            <Collapse in={expandedPayment === 'payu'}>
                                <Box p={2}>
                                    <div
                                        style={{
                                            border: '2px dashed #d1d5db',
                                            borderRadius: 10,
                                            backgroundColor: '#F9FAFB',
                                            padding: '25px 20px',
                                            textAlign: 'center',
                                            margin: 'auto',
                                        }}
                                    >
                                        <div
                                            style={{
                                                backgroundColor: '#e0f2fe',
                                                width: 60,
                                                height: 60,
                                                borderRadius: '50%',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                margin: '0 auto 15px',
                                            }}
                                        >
                                            <ShieldIcon />
                                        </div>

                                        <h3 style={{ margin: 0, fontSize: 18, color: '#111827' }}>
                                            Pago Seguro con Stripe/Tarjeta
                                        </h3>
                                        <p
                                            style={{
                                                margin: '8px 0 20px',
                                                color: '#6b7280',
                                                fontSize: 14,
                                            }}
                                        >
                                            Completa tu pago de forma segura usando tu método
                                            preferido
                                        </p>

                                        <div
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'center',
                                                gap: 10,
                                            }}
                                        >
                                            <span
                                                style={{
                                                    backgroundColor: '#2563eb',
                                                    color: '#fff',
                                                    fontSize: 12,
                                                    fontWeight: 'bold',
                                                    padding: '5px 10px',
                                                    borderRadius: 5,
                                                }}
                                            >
                                                VISA
                                            </span>
                                            <span
                                                style={{
                                                    backgroundColor: '#dc2626',
                                                    color: '#fff',
                                                    fontSize: 12,
                                                    fontWeight: 'bold',
                                                    padding: '5px 10px',
                                                    borderRadius: 5,
                                                }}
                                            >
                                                MC
                                            </span>
                                            <span
                                                style={{
                                                    backgroundColor: '#16a34a',
                                                    color: '#fff',
                                                    fontSize: 12,
                                                    fontWeight: 'bold',
                                                    padding: '5px 10px',
                                                    borderRadius: 5,
                                                }}
                                            >
                                                PSE
                                            </span>
                                        </div>
                                    </div>
                                    <div
                                        style={{
                                            padding: '15px 20px',
                                            margin: '15px auto 0',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'space-between',
                                        }}
                                    >
                                        <Typography>Renovar automáticamente</Typography>
                                        <Switch
                                            checked={autoRenew}
                                            onChange={(e) => setAutoRenew(e.target.checked)}
                                            color="primary"
                                        />
                                    </div>
                                </Box>
                            </Collapse>
                        </Box>

                        {/* WhatsApp Option */}
                        <Box className={classes.paymentOption}>
                            <Button
                                className={classes.paymentButton}
                                onClick={() => togglePaymentOption('whatsapp')}
                            >
                                <Box display="flex" style={{ gap: 8 }}>
                                    <Radio
                                        checked={selectedPaymentMethod === 'whatsapp'}
                                        value="whatsapp"
                                        color="primary"
                                    />
                                    <WhatsAppIcon style={{ color: '#22c55e' }} />
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'column',
                                            alignItems: 'flex-start',
                                        }}
                                    >
                                        <Typography>Pagar por WhatsApp</Typography>
                                        <Typography variant="body2" style={{ color: '#C0C1BE' }}>
                                            Un asesor te ayudará a completar el pago
                                        </Typography>
                                    </div>
                                </Box>
                                <ExpandMoreIcon
                                    style={{
                                        transform:
                                            expandedPayment === 'whatsapp'
                                                ? 'rotate(180deg)'
                                                : 'none',
                                    }}
                                />
                            </Button>
                            <Collapse in={expandedPayment === 'whatsapp'}>
                                <Box
                                    p={2}
                                    style={{
                                        backgroundColor: '#ecfdf5',
                                        borderRadius: '10px',
                                        padding: '30px 20px',
                                        textAlign: 'center',
                                        margin: 'auto',
                                        boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
                                    }}
                                >
                                    <div
                                        style={{
                                            backgroundColor: '#22c55e',
                                            width: '60px',
                                            height: '60px',
                                            borderRadius: '50%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            margin: '0 auto 15px',
                                        }}
                                    >
                                        <WhatsAppIcon />
                                    </div>

                                    <h3 style={{ color: '#14532d', margin: 0, fontSize: '18px' }}>
                                        Pago Asistido por WhatsApp
                                    </h3>
                                    <p
                                        style={{
                                            color: '#6b7280',
                                            margin: '8px 0 20px',
                                            fontSize: '14px',
                                        }}
                                    >
                                        Nuestro equipo te guiará paso a paso para completar tu pago
                                        de forma rápida y segura
                                    </p>

                                    <ul
                                        style={{
                                            listStyle: 'none',
                                            padding: 0,
                                            margin: 0,
                                            textAlign: 'left',
                                            display: 'inline-block',
                                        }}
                                    >
                                        <li
                                            style={{
                                                marginBottom: '8px',
                                                color: '#14532d',
                                                fontSize: '14px',
                                            }}
                                        >
                                            <CheckCircleIcon /> Atención personalizada en tiempo
                                            real
                                        </li>
                                        <li
                                            style={{
                                                marginBottom: '8px',
                                                color: '#14532d',
                                                fontSize: '14px',
                                            }}
                                        >
                                            <CheckCircleIcon /> Múltiples opciones de pago
                                            disponibles
                                        </li>
                                        <li
                                            style={{
                                                marginBottom: 0,
                                                color: '#14532d',
                                                fontSize: '14px',
                                            }}
                                        >
                                            <CheckCircleIcon /> Soporte técnico inmediato tras el
                                            pago
                                        </li>
                                    </ul>
                                </Box>
                            </Collapse>
                        </Box>
                    </RadioGroup>

                    {/* Total & Checkout */}
                    <div
                        style={{
                            paddingTop: '12px',
                            margin: 'auto',
                            textAlign: 'center',
                            position: 'sticky',
                            bottom: 12,
                            background: '#FFFFFF',
                        }}
                    >
                        {/* <div
                            style={{
                                padding: '20px',
                                margin: 'auto',
                                textAlign: 'center',
                                display: 'flex',
                                gap: '8px',
                            }}
                        >
                            <OutlinedInput
                                value={promoCode}
                                placeholder="Introduce tu código"
                                onChange={(e) => setPromoCode(e.target.value)}
                                fullWidth
                                size="small"
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={handleValidatePromoCode}
                            >
                                Validar
                            </Button>
                        </div> */}
                        <div
                            style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                marginBottom: '10px',
                            }}
                        >
                            <p style={{ margin: 0, color: '#6b7280', fontSize: '14px' }}>
                                Total a pagar:
                            </p>
                            <div style={{ textAlign: 'right' }}>
                                <p
                                    style={{
                                        margin: 0,
                                        color: '#111827',
                                        fontWeight: 'bold',
                                        fontSize: '16px',
                                    }}
                                >
                                    {totalToPay}
                                </p>
                                {/* savingsText oculto temporalmente
                                <p
                                    style={{
                                        margin: '2px 0 0',
                                        color: '#16a34a',
                                        fontSize: '13px',
                                    }}
                                >
                                    {savingsText}
                                </p>
                                */}
                            </div>
                        </div>

                        <div>
                            <Button
                                fullWidth
                                variant="contained"
                                color="primary"
                                startIcon={<span>👑</span>}
                                style={{ marginTop: 24 }}
                                onClick={handleCompletePayment}
                                disabled={!selectedPaymentMethod}
                            >
                                Completar activación
                            </Button>

                            <p style={{ marginTop: '10px', color: '#9ca3af', fontSize: '12px' }}>
                                Al continuar aceptas nuestros términos y condiciones
                            </p>
                        </div>
                    </div>
                </Box>
            </Dialog>
        );
    };

    // --- SUCCESS SCREEN ---
    const renderSuccess = () => (
        <Dialog open={open} onClose={onClose}>
            <Box className={classes.header}>
                <Box className={classes.successIcon}>
                    <CheckIcon style={{ color: '#16a34a', fontSize: 48 }} />
                </Box>
                {/* {selectedPaymentMethod === 'payu' && (
                    <Typography
                        variant="h4"
                        style={{ fontWeight: 'bold', marginBottom: 8, textAlign: 'center' }}
                    >
                        ¡Bienvenido a Pro!
                    </Typography>
                )} */}
            </Box>
            <Box className={classes.content}>
                <Typography
                    variant="body1"
                    color="textSecondary"
                    style={{ marginBottom: 32, textAlign: 'center' }}
                >
                    {selectedPaymentMethod === 'whatsapp'
                        ? 'Completa el pago por WhatsApp, tu plan premium se activa con el asesor.'
                        : 'Completa la activación de tu plan en WhatsApp'}
                    {/* : 'Tu cuenta ha sido actualizada exitosamente'} */}
                </Typography>
                {/* {selectedPaymentMethod === 'payu' && (
                    <Button
                        fullWidth
                        variant="outlined"
                        style={{
                            borderColor: '#d1d5db',
                            color: '#1E1E1E',
                            textTransform: 'none',
                        }}
                        onClick={onConfigureStoreClick}
                    >
                        Configurar mi tienda
                    </Button>
                )} */}
                {selectedPaymentMethod === 'payu' && (
                    <Button
                        fullWidth
                        variant="contained"
                        color="primary"
                        style={{ marginBottom: 16 }}
                        onClick={handleOpenWhatsapp}
                    >
                        Contactar soporte por WhatsApp
                    </Button>
                )}
                <Button
                    fullWidth
                    variant="outlined"
                    style={{
                        borderColor: '#d1d5db',
                        color: '#1E1E1E',
                    }}
                    onClick={onClose}
                >
                    Cerca
                    {/* {selectedPaymentMethod === 'whatsapp' ? 'Cerca' : 'Comenzar a usar Pro'} */}
                </Button>
            </Box>
        </Dialog>
    );

    return (
        <ThemeProvider theme={theme}>
            {screen === 'plans' && renderPlans()}
            {screen === 'payment' && renderPayment()}
            {screen === 'success' && renderSuccess()}
        </ThemeProvider>
    );
};

const mapStateToProps = ({ auth }) => ({
    storeId: auth.storeId,
});

export default connect(mapStateToProps)(ModalUpgradePlan);
